import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
export function InvestmentPage() {
  return <div className="bg-brand-beige" data-id="element-310">
      <PageHero title="Investment & Growth" subtitle="Strategic capital allocation to scale proven concepts." data-id="element-311" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-312">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-313"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-314">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-315">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-316">
              <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-317">
                Portfolio Highlights
              </h2>
              <div className="w-16 h-1 bg-brand-red mb-8" data-id="element-318"></div>
              <p className="text-lg text-brand-dark/80 font-light leading-relaxed mb-6" data-id="element-319">
                Our investment strategy focuses on high-yield hospitality assets
                with strong brand equity and operational scalability. We target
                concepts that demonstrate resilience and appeal to evolving
                consumer preferences.
              </p>
              <ul className="space-y-4 text-brand-dark/70 font-light" data-id="element-320">
                <li className="flex items-center gap-3" data-id="element-321">
                  <div className="w-1.5 h-1.5 bg-brand-gold rounded-full" data-id="element-322"></div>{' '}
                  15% Average YoY Portfolio Growth
                </li>
                <li className="flex items-center gap-3" data-id="element-323">
                  <div className="w-1.5 h-1.5 bg-brand-gold rounded-full" data-id="element-324"></div>{' '}
                  $50M+ Assets Under Management
                </li>
                <li className="flex items-center gap-3" data-id="element-325">
                  <div className="w-1.5 h-1.5 bg-brand-gold rounded-full" data-id="element-326"></div>{' '}
                  Successful incubation of 4 proprietary brands
                </li>
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-327">
              <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80" alt="Financial charts" className="w-full h-[500px] object-cover rounded-sm shadow-2xl" data-id="element-328" />
            </motion.div>
          </div>

          {/* Inquiry Form */}
          <motion.div className="bg-brand-dark p-10 md:p-16 rounded-sm shadow-2xl max-w-4xl mx-auto relative" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-329">
            <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-330"></div>
            <div className="relative z-10" data-id="element-331">
              <div className="text-center mb-12" data-id="element-332">
                <h3 className="text-3xl font-serif text-white mb-4" data-id="element-333">
                  Investor Inquiry
                </h3>
                <p className="text-white/60 font-light" data-id="element-334">
                  Contact our investment relations team to discuss current
                  opportunities.
                </p>
              </div>

              <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-335">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-336">
                  <div data-id="element-337">
                    <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-338">
                      Name
                    </label>
                    <input type="text" className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-339" />
                  </div>
                  <div data-id="element-340">
                    <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-341">
                      Organization
                    </label>
                    <input type="text" className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-342" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-343">
                  <div data-id="element-344">
                    <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-345">
                      Email Address
                    </label>
                    <input type="email" className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors" data-id="element-346" />
                  </div>
                  <div data-id="element-347">
                    <label className="block text-xs uppercase tracking-widest text-white/50 mb-2" data-id="element-348">
                      Investment Interest
                    </label>
                    <select className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:outline-none focus:border-brand-gold transition-colors appearance-none" data-id="element-349">
                      <option className="text-brand-dark" data-id="element-350">
                        Equity Partnership
                      </option>
                      <option className="text-brand-dark" data-id="element-351">
                        Real Estate Fund
                      </option>
                      <option className="text-brand-dark" data-id="element-352">
                        Franchise Opportunities
                      </option>
                    </select>
                  </div>
                </div>
                <button className="w-full bg-brand-gold text-brand-dark py-4 text-sm uppercase tracking-[0.2em] font-medium hover:bg-white transition-colors mt-4" data-id="element-353">
                  Submit Inquiry
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}